/**
 * Sign-in popup.
 *
 * Upgrades the "Sign in to check out" link into a popup window so the shopper
 * keeps their cart on screen instead of the page navigating away mid-purchase.
 * webpunk.com runs Privy in the popup, mints a ref, and hands it back — either
 * by postMessage, or via the `.webpunk.com` cookie it sets, which this page can
 * read because both hosts sit under the same registrable domain.
 *
 * The anchor stays a real link: without JS, or if the browser blocks the popup,
 * the click falls through to a normal navigation and nothing is lost.
 */
(function () {
  var TOKEN = /^[A-Za-z0-9_-]{16,64}$/;
  var POLL_MS = 500;

  function origin(link) {
    try {
      return new URL(link.href).origin;
    } catch (err) {
      return null;
    }
  }

  function readCookie(name) {
    var parts = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < parts.length; i++) {
      var pair = parts[i].split('=');
      if (pair.shift().trim() === name) {
        try {
          return decodeURIComponent(pair.join('='));
        } catch (err) {
          return null;
        }
      }
    }
    return null;
  }

  function adopt(ref) {
    var identity = window.webpunkIdentity;
    if (!identity || !identity.adopt) return;
    identity.adopt(ref).then(function (ok) {
      // Reload so the gate re-renders from Liquid with the ref on the cart —
      // the server is the source of truth for which button belongs here.
      if (ok) window.location.reload();
    });
  }

  function attach(link) {
    var expected = origin(link);

    link.addEventListener('click', function (evt) {
      // Let modified clicks (new tab, etc.) behave normally.
      if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.button !== 0) return;

      var w = Math.min(480, window.screen.availWidth);
      var h = Math.min(720, window.screen.availHeight);
      var left = window.screenX + (window.outerWidth - w) / 2;
      var top = window.screenY + (window.outerHeight - h) / 2;

      var popup = window.open(
        link.href,
        'webpunk-signin',
        'width=' + w + ',height=' + h + ',left=' + left + ',top=' + top +
          ',menubar=no,toolbar=no,location=yes,status=no,resizable=yes,scrollbars=yes'
      );

      // Blocked, or opened in a tab that returned null — let the link navigate.
      if (!popup) return;

      evt.preventDefault();
      popup.focus();

      var settled = false;

      function finish(ref) {
        if (settled || !ref || !TOKEN.test(ref)) return;
        settled = true;
        window.removeEventListener('message', onMessage);
        window.clearInterval(timer);
        try {
          popup.close();
        } catch (err) {
          /* already gone, or cross-origin at this instant */
        }
        adopt(ref);
      }

      function onMessage(event) {
        if (expected && event.origin !== expected) return;
        var data = event.data;
        if (!data || data.type !== 'webpunk:shop-ref') return;
        finish(data.ref);
      }

      window.addEventListener('message', onMessage);

      // Fallback for browsers that lose the postMessage (or a popup the user
      // closes by hand after signing in): the shared cookie is authoritative.
      var timer = window.setInterval(function () {
        var cookieRef = readCookie('wp_ref');
        if (cookieRef) return finish(cookieRef);
        if (popup.closed) {
          window.clearInterval(timer);
          window.removeEventListener('message', onMessage);
        }
      }, POLL_MS);
    });
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-webpunk-signin]')).forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
